import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    cursor: 'pointer'
  },

  avatarArea: {
    marginLeft: '8px'
  },

  avatar: {
    width: '24px',
    height: '24px'
  },

  detailsArea: {
    display: 'flex',
    flexDirection: 'column',
    marginLeft: '8px',

    '& > :not(:last-child)': {
      marginBottom: '4px'
    }
  },

  name: {
    fontSize: theme.size.base,
    color: '#1F1F1F',
    cursor: 'inherit'
  },

  detailRow: {
    display: 'flex',
    alignItems: 'center',

    '& .flag': {
      marginRight: '8px'
    }
  },

  detailValue: {
    fontSize: theme.size.sm,
    color: '#8F8F8F'
  },

  detailPhone: {},

  mockAvatar: {
    borderRadius: '50%',
    animation: '$skeleton-loading 0.3s linear infinite alternate'
  },

  mockName: {
    marginLeft: '16px',
    borderRadius: '10px',
    width: '50%',
    height: '17px',
    animation: '$skeleton-loading 0.3s linear infinite alternate'
  },

  '@keyframes skeleton-loading': {
    '0%': {
      backgroundColor: 'hsl(0, 0%, 90%)'
    },

    '100%': {
      backgroundColor: 'hsl(0, 0%, 93%)'
    }
  }
}))

export default useStyles
